import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { accessToken } from '../api/auth'
import { getParsedLocalStorageItem } from '../js/script'

export default function Bridge() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://shop-api.e-ncp.com/payments/ncp_pay.js'
    script.async = true
    document.body.appendChild(script)

    const script2 = document.createElement('script')
    script2.src = 'https://spay.kcp.co.kr/plugin/kcp_spay_hub.js'
    script2.async = true
    document.body.appendChild(script2)

    const script3 = document.createElement('script')
    script3.src = 'https://nsp.pay.naver.com/sdk/js/naverpay.min.js'
    script3.async = true
    document.body.appendChild(script3)

    const script4 = document.createElement('script')
    script4.src = 'https://spay.kcp.co.kr/plugin/kcp_spay_hub.js'
    script4.async = true
    document.body.appendChild(script4)

    const script5 = document.createElement('script')
    script5.src = 'https://wcs.naver.net/wcslog.js'
    script5.async = true
    document.body.appendChild(script5)

    const script7 = document.createElement('script')
    script7.src = 'https://xpay.tosspayments.com/xpay/js/xpay_crossplatform.js'
    script7.async = true
    document.body.appendChild(script7)
  }, [])

  useEffect(() => {
    const myPayData = getParsedLocalStorageItem('myPayData')
    if (myPayData) {
      setTimeout(() => {
        const option = {
          clientReturnUrl: `${process.env.REACT_APP_SHOP_URL}/closet`,
          payMethod: '01',
        }
        if (window.NCPPay) {
          window.NCPPay.setMyPayCssCustom(
            `https://shop-api.e-ncp.com${myPayData.customCssUrl}`,
            null,
            `${myPayData.payName}`,
            null
          )
          window.NCPPay?.setConfiguration({
            clientId: process.env.REACT_APP_CLIENT_ID, // shopby에서 발급받은 clientId
            confirmUrl: `${process.env.REACT_APP_SHOP_URL}/closet`, // 결과를 리턴받을 url
            platform: isMobile ? 'MOBILE_WEB' : 'PC', // 'PC or MOBILE_WEB or AOS or IOS'
            accessToken: accessToken ? accessToken : '', // 로그인한 사람의 accessToken
            withCredentials: true,
          })
          window.NCPPay.requestMyPayApi(option, 'REGISTER_PAYMENT')
        }
      }, 200)
    }
  }, [])

  return null
}
